import React from 'react';
import { motion } from 'framer-motion';
import { FilePage } from './FilePage';
import { EvidencePlate } from './EvidencePlate';
import { offerItems } from '../data/offer';
export function EvidenceSection() {
  return <FilePage id="oferta" number="04" label="La Oferta" data-id="element-188" data-mp="n3hbzojf9usl">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.5
    }} transition={{
      duration: 0.6
    }} className="max-w-[42rem]" data-id="element-189" data-mp="j2xc4d7gsd2r">
        <p className="font-display text-[1.3rem] font-bold leading-snug text-bone sm:text-[1.9rem]" data-id="element-190" data-mp="94hv5325ik6z">
          Esto no es solo un curso. Es un{' '}
          <span className="gold-text" data-id="element-191" data-mp="47r8fwvucqcl">Sistema de Armamento Visual</span>.
        </p>
        <p className="mt-3 text-[14.5px] leading-relaxed text-ash sm:mt-4 sm:text-[15px]" data-id="element-192" data-mp="5w5yp26c6x8">
          Al adquirirlo hoy recibes el expediente completo: seis archivos sellados
          que trabajan juntos.
        </p>
      </motion.div>

      <div className="mt-7 flex items-center gap-3 sm:mt-10" data-id="element-193" data-mp="3empketgbwwj2">
        <span className="font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-194" data-mp="3eled4jnod6n7">
          Evidencia adjunta — 6 archivos sellados
        </span>
        <span aria-hidden="true" className="h-px flex-1 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.14)_0_6px,transparent_6px_12px)]" data-id="element-195" data-mp="35mt0f54vwluc" />
      </div>

      <div className="mt-5 grid gap-4 sm:mt-7 sm:grid-cols-2 sm:gap-6 xl:grid-cols-3" data-id="element-196" data-mp="17b27wfg0yll">
        {offerItems.map((item, index) => <EvidencePlate key={item.id} item={item} index={index} data-id="element-197" data-mp="65kzqdon4bad" data-mpi={index} />)}
      </div>
    </FilePage>;
}